import {Component, Input} from '@angular/core';
import {CompanyResponse, MembershipPlanResponse} from '../../../../@shared/models/response.module';
import {MembershipService} from '../../../../@shared/services/membership-service';
import {AQH_MEM_4, _AQH_MEM_7} from '../../../../@shared/models/input.module';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AddMembershipPlan} from './components/add-membership-plan/add-membership-plan';
import {EditMembershipPlan} from './components/edit-membership-plan/edit-membership-plan';

@Component({
  selector: 'app-company-profile-membership-plans',
  standalone: false,
  templateUrl: './company-profile-membership-plans.html',
  styleUrl: './company-profile-membership-plans.css'
})
export class CompanyProfileMembershipPlans {
  @Input() company: CompanyResponse;
  plans: MembershipPlanResponse[] = [];
  loading: boolean = false;

  constructor(private membershipService: MembershipService,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.loadPlans();
  }

  loadPlans() {
    this.loading = true;
    const params: AQH_MEM_4 = {
      company_id: this.company.company_id
    };

    this.membershipService.getMembershipPlans(params).subscribe({
      next: (plans) => {
        this.plans = plans;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  openAddPlanModal() {
    let modalRef = this.modalService.open(AddMembershipPlan, {centered: true, size: 'lg'});
    modalRef.result.then((result) => {
      if (result) {
        this.loadPlans();
      }
    }).catch(() => {});
  }

  openEditPlanModal(plan: MembershipPlanResponse) {
    let modalRef = this.modalService.open(EditMembershipPlan, {centered: true, size: 'lg'});
    modalRef.componentInstance.plan = plan;
    modalRef.result.then((result) => {
      if (result) {
        this.loadPlans();
      }
    }).catch(() => {});
  }

  deletePlan(plan: MembershipPlanResponse) {
    if (!confirm(`Are you sure you want to delete the plan "${plan.name}"?`)) {
      return;
    }

    const params: _AQH_MEM_7 = {
      plan_id: plan.plan_id
    };

    this.membershipService.deleteMembershipPlan(params).subscribe({
      next: () => {
        this.loadPlans();
      }
    });
  }

  formatPrice(cents: number): string {
    return (cents / 100).toFixed(2);
  }
}
